import { toDate, toNumber } from '@rahtab/system/lib/tools/string';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deserialize, serialize } from 'class-transformer';
import { SliceState } from 'interfaces';
import { RootState } from 'rahtab-redux';
import { RevisionList } from '../../hooks/InventoryHooks/useLoadRevisionList';

const initialState: CorrectionSliceState = {
  loading: 'idle',
  corrections: {},
};

const correctionSlice = createSlice({
  name: 'correctionList',
  initialState,
  reducers: {
    setCorrectionsLoading(state, { payload }: PayloadAction<CorrectionSliceState['loading']>) {
      state.loading = payload;
    },
    addCorrection(state, { payload }: PayloadAction<RevisionList & { id: string }>) {
      state.corrections[payload.id] = {
        amount: toNumber(payload.Amount),
        reason: payload.ReasonName,
        submitDate: <Date>(<unknown>serialize(toDate(payload.CorrectionDate))),
        unitText: payload.Measurename,
      };
    },
  },
});

const { actions, reducer } = correctionSlice;

export const { addCorrection, setCorrectionsLoading } = actions;

export default reducer;

export function correctionListSelector(ids: string[], assignFinalCode: string) {
  return (state: RootState) => {
    const { correctionList } = state;
    return ids.map((id) => {
      return {
        ...correctionList.corrections[`${assignFinalCode}-${id}`],
        submitDate: deserialize(
          Date,
          <string>(<unknown>correctionList.corrections[`${assignFinalCode}-${id}`].submitDate),
        ),
      };
    });
  };
}
type CorrectionSliceState = SliceState<'corrections', CorrectionList>;

interface CorrectionList {
  amount: number;
  submitDate: Date;
  unitText: string;
  reason: string;
}
